export interface EmptyOutdatedQuestions {
  responseData: {
    question_list: {
      step?: [
        {
          stepNumber?: number;
          questionNumber?: number;
          order?: number;
          lastUpdateDate?: number;
          valueEmpty?: boolean;
        }
      ];
    };
  };
}
